import { schema } from 'normalizr';

export const TIMELINE_SCHEMA_KEY = 'timeline';
export const timelineSchema = new schema.Entity(TIMELINE_SCHEMA_KEY);
export const timelineListSchema = [timelineSchema];
